"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastMapEntry = void 0;
exports.lastMapEntry = (map) => Array.from(map)[map.size - 1];
//# sourceMappingURL=last-map-entry.js.map